import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "buttonContainer" }
const _hoisted_6 = { class: "buttonContainer" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.ready)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "root",
        class: _normalizeClass(["introductionStep", { hasVideo: $setup.computedStep.video !== undefined }])
      }, [
        ($setup.computedStep.modal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nge-overlay-blocker",
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
            }, null, 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(["ng-extend introductionStepAnchor chipBuildIn", $setup.computedStep.cssClass]),
          style: _normalizeStyle({ left: $setup.computedStep.left, top: $setup.computedStep.top })
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "arrow" }, null, -1 /* HOISTED */)),
          (!$setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["chip", { modal: $setup.computedStep.modal, noborder: $setup.computedStep.noborder }]),
                style: _normalizeStyle($setup.chipBounds)
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "corner corner-tl" }, null, -1 /* HOISTED */)),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "corner corner-tr" }, null, -1 /* HOISTED */)),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "corner corner-bl" }, null, -1 /* HOISTED */)),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "corner corner-br" }, null, -1 /* HOISTED */)),
                _createElementVNode("button", {
                  class: "exit",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.inExitConfirm = true))
                }, "×"),
                ($setup.computedStep.title)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($setup.computedStep.title), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.video)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      width: "350",
                      height: "242.81",
                      autoplay: "",
                      loop: "",
                      muted: "",
                      playsinline: "",
                      src: $setup.computedStep.video
                    }, null, 8 /* PROPS */, _hoisted_2))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: "image",
                      src: $setup.computedStep.image
                    }, null, 8 /* PROPS */, _hoisted_3))
                  : _createCommentVNode("v-if", true),
                ($setup.computedStep.html)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "html",
                      innerHTML: $setup.computedStep.html
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_5, [
                  (!$setup.computedStep.first)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back'))),
                        class: "back"
                      }, "back"))
                    : _createCommentVNode("v-if", true),
                  ($setup.computedStep.last)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.launchConfetti(); _ctx.$emit('next')}),
                        class: "next"
                      }, "done"))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('next'))),
                        class: "next"
                      }, _toDisplayString($setup.computedStep.nextLabel || 'next'), 1 /* TEXT */))
                ])
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true),
          ($setup.inExitConfirm)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["chip exitConfirm", { modal: $setup.computedStep.modal }]),
                style: _normalizeStyle($setup.chipBounds)
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("div", null, "Do you want to exit the tutorial?", -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.inExitConfirm = false)),
                    class: "next"
                  }, "No"),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('exitIntro'))),
                    class: "next"
                  }, "Yes")
                ])
              ], 6 /* CLASS, STYLE */))
            : _createCommentVNode("v-if", true)
        ], 6 /* CLASS, STYLE */),
        ($setup.computedStep.floatingImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "floatingImage",
              src: $setup.computedStep.floatingImage
            }, null, 8 /* PROPS */, _hoisted_7))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}